var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDobleFlechaDerecha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3 8.24267L3 4.94267L3.94267 4L8.18533 8.24267L3.94267 12.4853L3 11.5427L6.3 8.24267Z",
    fill: "#115896"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3 8.24267L7 4.94267L7.94267 4L12.1853 8.24267L7.94267 12.4853L7 11.5427L10.3 8.24267Z",
    fill: "#115896"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDobleFlechaDerecha);
export default __webpack_public_path__ + "static/media/dobleFlechaDerecha.230505afe8fb08841acfa5bc0d945a2f.svg";
export { ForwardRef as ReactComponent };